<template>
  <div class="vacancy-video-base">
    <vtitle />

    <vacancy-stage-title
      :name="name"
      :description="description"
      :is-loading="loading"
      @set-name="$emit('set-name', $event)"
      @set-description="$emit('set-description', $event)"
    />

    <div v-if="videointerview.id" class="videointerview-settings">
      <div class="page_video_info">
        <div class="chebox-section">
          <vchecklabel v-model="isVideoAnswerEnabled" :label="$tr('vacancy.videointerview.isAudiointerview')" />
        </div>
      </div>

      <div class="video-block">
        <question-list :value="questions" :vacancy-id="vacancyId" @change="$emit('set-questions', $event)" />
      </div>

      <div class="row-block button-wrapper">
        <vbutton label="vacancy.videoInterview.add" type="add" @click="add_question" />

        <vbutton
          class="vacancy-button"
          :loading="loading"
          :disabled="is_disabled || loading"
          label="common.save"
          @click="$emit('save-videointerview')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import QuestionList from '@/routes_new/inner/vacancy/video/base/questions/List';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle';
import VacancyStageTitle from '@/routes_new/inner/vacancy/components/VacancyStageTitle.vue';

export default {
  name: 'VacancyVideointerviewView',

  components: {
    QuestionList,
    VacancyStageTitle,
    vtitle
  },

  props: {
    loading: Boolean,

    name: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    videointerview: {
      type: Object,
      default: () => {}
    },

    questions: {
      type: Array,
      default: () => []
    },

    vacancyId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      tpmIsVideoAnswerEnabled: null
    };
  },

  computed: {
    is_disabled() {
      if (!this.questions || !this.questions.length) {
        return false;
      }

      return !!this.questions.filter(item => {
        let video = item.video && item.video_title;
        let isEmpty = item.body.length === 0 && !item.video_url && !video;
        return isEmpty || item._youtube_error;
      }).length;
    },

    isVideoAnswerEnabled: {
      get() {
        if (this.tpmIsVideoAnswerEnabled === null) {
          return this.videointerview.is_video_answer_enabled !== undefined
            ? !this.videointerview.is_video_answer_enabled
            : false;
        }
        return this.tpmIsVideoAnswerEnabled;
      },

      set(val) {
        this.tpmIsVideoAnswerEnabled = val;
        this.$emit('update', {
          is_video_answer_enabled: !val
        });
      }
    }
  },

  mounted() {
    VueScrollTo.scrollTo(document.querySelector('.app'), 0);
    // VueScrollTo.scrollTo(document.querySelector('.videointerview-settings'), 100)
  },

  methods: {
    add_question() {
      this.$emit('add-question');
      VueScrollTo.scrollTo(document.querySelector('.sortable-item:last-child'), 800);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vacancy-video-base {
  max-width: 700px;
}

.form-title {
  font-size: 22px;
  color: #333333;
}

.heading {
  justify-content: space-between;
}

.video-block {
  margin-bottom: 10px;
  margin-top: 48px;
}

.page_video_info {
  .page_video_title {
    @include mixin-text-header;
    margin-bottom: 10px;
  }

  .page_video_textarea {
    width: 100%;
    min-height: 164px;
    max-height: 164px;
  }
}

.row-block {
  margin-bottom: 35px;
}

.button-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;

  .vacancy-button:not(:last-child) {
    margin-right: 10px;
  }
}

.chebox-section {
  margin-top: 20px;
}
</style>
